import React from "react";

const TermsOfUse = () => {
  return (
    <div className="max-w-5xl mx-auto px-6 py-12 text-gray-800">
      <h1 className="text-3xl font-bold mb-6">Terms of Use</h1>

      <p className="mb-6">
        By accessing and using Paingoriya & Associates services, you agree to
        comply with the following terms.
      </p>

      <h2 className="text-xl font-semibold mt-6 mb-2">
        1. Services
      </h2>
      <p className="mb-4">
        All services are provided for informational and professional purposes
        only.
      </p>

      <h2 className="text-xl font-semibold mt-6 mb-2">
        2. User Responsibility
      </h2>
      <p className="mb-4">
        Users are responsible for providing accurate and complete information.
      </p>

      <h2 className="text-xl font-semibold mt-6 mb-2">
        3. Intellectual Property
      </h2>
      <p className="mb-4">
        All content on this website is the property of Paingoriya & Associates
      </p>

      <h2 className="text-xl font-semibold mt-6 mb-2">
        4. Modifications
      </h2>
      <p className="mb-4">
        We reserve the right to modify these terms at any time.
      </p>
    </div>
  );
};

export default TermsOfUse;
